import { render, staticRenderFns } from "./paperclip.vue?vue&type=template&id=063c5c2a&"
import script from "./paperclip.vue?vue&type=script&lang=js&"
export * from "./paperclip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports